var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('h2',[_vm._v("Corporate")])]),_c('v-col',{attrs:{"cols":"12"}},[_c('corporate-engagement')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }